import { render, staticRenderFns } from "./SOV3Detailed.vue?vue&type=template&id=36d3f098&scoped=true"
import script from "./SOV3Detailed.vue?vue&type=script&lang=js"
export * from "./SOV3Detailed.vue?vue&type=script&lang=js"
import style0 from "./SOV3Detailed.vue?vue&type=style&index=0&id=36d3f098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d3f098",
  null
  
)

export default component.exports